export default "__VITE_ASSET__DiuT2ERP__"